<!-- @format -->

<!--
 * Datei: Footer.vue
 * Projekt: novagraphix_nuxt_template
 * Erstellt: 20.08.2019, 15:34:41
 * Autor: Stephan Jess
 * -----
 * Zuletzt bearbeitet: 20.08.2019 15:34:41
 * von:  Stephan Jess (s.jess@novagraphix.de>)
 * -----
 * Copyright (c) 2019 Novagraphix GmbH & Co. KG
 * -----
 -->

<template>
  <div>
    <social class="lg:m-0" />
    <div
      class="flex flex-col md:flex-row sm:justify-center mb-2 font-bold text-base navpoints mb-4 sm:mb-0 text-secondary uppercase"
    >
      <a href="https://www.alamodefilm.de/" target="_blank">Alamode Webseite</a>
      <a href="https://www.alamodefilm.de/presse.html" target="_blank"
        >Presse</a
      >
      <a href="https://www.alamodefilm.de/impressum.html" target="_blank"
        >IMPRESSUM</a
      >
      <a href="https://www.alamodefilm.de/datenschutz.html" target="_blank"
        >DATENSCHUTZ</a
      >
    </div>
    <div class="relative mt-2 mb-4 text-xs text-secondary">
      &copy; 2019 ALAMODE FILMDISTRIBUTION oHG. Alle Rechte vorbehalten made by
      <a
        class="text-secondary hover:text-black"
        href="http://www.novagraphix.de"
        target="_blank"
        >novagraphix</a
      >
    </div>
  </div>
</template>

<script>
  import Social from '@/components/Base/Elements/Companies/alamode/Social.vue'

  export default {
    components: { Social },
  }
</script>
